import GridSortFns from './entities/GridSortFns';

export const sortByNumber = new GridSortFns(
  (a, b) => parseFloat(a) - parseFloat(b),
  (a, b) => parseFloat(b) - parseFloat(a),
);

export const sortByAlphabet = new GridSortFns(
  (a, b) => a - b,
  (a, b) => b - a,
);

export const sortByDate = new GridSortFns(
  (a, b) => new Date(a) - new Date(b),
  (a, b) => new Date(b) - new Date(a),
);
